import { connect } from 'react-refetch';
import 'isomorphic-fetch';

export const appConnect = Component =>
  connect(() => ({
    resourcesFetch: '/resources/api/all'
  }))(Component);

export default {
  appConnect
};



// WEBPACK FOOTER //
// ./src/pages/resources/utils/connect.js